import OrderTableButton from "./OrderTableButton";

export default OrderTableButton;